import { noraWebTheme } from './noraWebTheme';
import { ThemeProvider,createTheme } from '@mui/material';

const BREAKPOINTS = {
  xs: 0,
  sm: 800,
  md: 1010,
  lg: 1230,
  xl: 1540,
};

const breakpointsValues = {
  breakpoints: {
    values: BREAKPOINTS
  }
};

export const HeaderTheme = createTheme({ ...noraWebTheme, ...breakpointsValues });
